import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { reducer } from './reducer';
import EventsTable from './events';
import moment from 'moment';

const initialState = {
  startDate: moment(new Date()).startOf('day').utc().toISOString(),
  endDate: moment(new Date()).endOf('day').utc().toISOString(),
};

const store = createStore(reducer, initialState);

const Stats = () => {
  return (
    <Provider store={store}>
      <EventsTable />
    </Provider>
  );
};

export default Stats;
